<template>
  <div class="vx-card">
    <div class="vx-card__collapsible-content">
      <div class="vx-card__body row">
        <div class="col-md-4 col-12">
          <h4 class="text-primary">Opciones</h4>
          <div v-if="isLoadOptions">
            <b-spinner
                key="primary"
                class="mr-1"
                variant="primary"
            />
          </div>
          <div
              class="input-group mb-3"
              v-if="!isLoadOptions"
          >
            <input
                v-model="search"
                type="text"
                class="form-control"
                placeholder="Buscar grupo de opciones"
                aria-label="Buscar grupo de opciones"
                aria-describedby="input-search"
            >
            <div
                class="input-group-append"
                v-if="checkIfIsSuperAdmin"
            >
              <button
                  class="btn btn-outline-secondary"
                  type="button"
                  v-b-tooltip="'Agregar nuevo grupo de opciones'"
                  v-on:click="addOptionGroup()"
              >
                <feather-icon icon="PlusIcon"/>
              </button>
            </div>
          </div>
          <ul class="list-group mt-5" style="max-height: 80vh; overflow: scroll">
            <li
                :key="'option-'+$indexParam"
                :id="'option-'+$indexParam"
                v-for="(option, $indexParam) in filteredOptions"
                class="list-group-item d-flex justify-content-between align-content-center"
            >
              <div class="d-flex flex-row">
                <div class="row">
                  <div class="col-md-12 col-12 mt-2">
                    <div class="about pr-3">
                      <span
                        @click="migrateOptionGroup(option)"
                        v-if="checkIfIsSuperAdmin"
                        v-tooltip="'Migrar Opción'"
                      >
                        <feather-icon
                          icon="SendIcon"
                          class="mr-1 cursor-pointer"
                        />
                      </span>
                      <span
                        @click="editOptionGroup(option)"
                        v-if="checkIfIsSuperAdmin"
                        v-tooltip="'Editar grupo de opciones'"
                      >
                        <feather-icon
                          icon="SettingsIcon"
                          class="mr-1 cursor-pointer"

                        />
                      </span>
                      <span
                        @click="deleteOptionGroup(option)"
                        v-if="checkIfIsSuperAdmin"
                        v-tooltip="'Ocultar grupo de opciones'"
                      >
                        <feather-icon
                          icon="TrashIcon"
                          color="red"
                          class="mr-1 cursor-pointer"
                        />
                      </span>
                      <label
                          v-on:click="selectOptionPatent(option)"
                          class="ml-4 cursor-pointer"
                      >
                        {{ option.descripcion }}
                        <small v-if="option.valor" class="d-block text-muted">{{ option.valor }}</small>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div
            class="col-8"
            v-if="optionSelected"
        >
          <div>
            <options-configurations-tree
                v-if="optionSelected.extra.type === 'tree' "
                :key="'config-panel-'+optionSelected.opcionId"
                :title="optionSelected.descripcion"
                :group-id="optionSelected.valor"
                :children-levels-limit="optionSelected.extra.maxTreeNodes || 2"
                :value-type-config="optionSelected.extra.valueTypes || 'text'"
                :extra-type-render="optionSelected.extra.extraRenderType || 'json'"
                :extras="optionSelected.extra || {}"
            />
            <options-configurations-list
                v-else
                :key="'config-panel-'+optionSelected.opcionId"
                :title="optionSelected.descripcion"
                :group-id="optionSelected.valor"
                :value-type-config="optionSelected.extra.valueTypes || 'text'"
                :extra-type-render="optionSelected.extra.extraRenderType || 'json'"
                :extras="optionSelected.extra || {}"
            />
          </div>
        </div>
      </div>
    </div>
    <b-modal
        id="option-config"
        ref="option-config"
        title="Configurar Grupo de opciones"
        hide-footer
        no-close-on-backdrop
        size="xl"
    >
      <div
          class="row mb-5"
          v-if="optionConfigure"
      >
        <div class="col-md-8 col-12 mt-3">
          <label>Nombre de la opción</label>
          <input
            class="form-control"
            v-model="optionConfigure.descripcion"
            maxlength="250"
          >
          <small class="form-text text-muted">Nombre para identificar la opción</small>
        </div>
        <div class="col-md-8 col-12 mt-3">
          <label>Descripcion de la opción</label>
          <input
            class="form-control"
            v-model="optionConfigure.extra.descripcion"
            maxlength="250"
          >
          <small class="form-text text-muted">Nombre para identificar la opción</small>
        </div>
        <div
          class="col-md-4 col-12 mt-3"
          v-if="checkIfIsSuperAdmin"
        >
          <label>Nivel de la opción  (grupo)</label>
          <select
            class="form-control"
            v-model="optionConfigure.nivel"
          >
            <option
              value="0"
              selected
            >
              Global
            </option>
            <option value="10">
              Empresa
            </option>
          </select>
          <small class="form-text text-muted">
            Nivel de visualización del tipo de opciones (grupo)
          </small>
        </div>
        <div
          class="col-md-4 col-12 mt-3"
          v-if="checkIfIsSuperAdmin"
        >
          <label>Nivel de la opción  (opciones)</label>
          <select
            class="form-control"
            v-model="optionConfigure.extra.nivel"
          >
            <option
              value="0"
              selected
            >
              Global
            </option>
            <option value="10">
              Empresa
            </option>
          </select>
          <small class="form-text text-muted">
            Nivel de visualización de las opciones
          </small>
        </div>
        <div class="col-md-6 col-12 mt-3">
          <label>Grupo de opción a configurar</label>
          <input
              class="form-control"
              v-model="optionConfigure.valor"
              maxlength="250"
          >
          <small class="form-text text-muted">
            Identificador de grupo sobre el cual se agruparan las opciones
          </small>
        </div>
        <div class="col-md-6 mt-3">
          <label>Tipo de valor de las opciones</label>
          <select
              class="form-control"
              v-model="optionConfigure.extra.valueTypes"
          >
            <option
                value="text"
                selected
            >
              Texto
            </option>
            <option value="number">Numero</option>
            <option value="text-large">Texto Largo</option>
            <option value="switch">Y o N</option>
            <option value="option">Opciones</option>
            <option value="s3-html">Html en S3</option>
            <option value="s3-text">Texto en S3</option>
            <option value="s3-xsl">XSL en S3</option>
            <option value="s3-file">Archivo en S3</option>
            <option value="s3-image">Imagen en S3</option>
            <option value="set">Set de configuraciones</option>
          </select>
          <small class="form-text text-muted">
            De que tipo son los valores que se configuraran en las opciones
          </small>
        </div>
        <div class="col-md-6 mt-3">
          <label>Como se muestra la información extra</label>
          <select
              class="form-control"
              v-model="optionConfigure.extra.extraRenderType"
          >
            <option
                value="json"
                selected
            >
              JSON
            </option>
          </select>
          <small class="form-text text-muted">
            Tipo de visualización del listado de opciones para su configuración
          </small>
        </div>
        <div class="col-md-6 mt-3">
          <label>Tipo de configuración</label>
          <select
              class="form-control"
              v-model="optionConfigure.extra.type"
          >
            <option
                value="list"
                selected
            >
              Lista
            </option>
            <option value="tree">
              Arbol
            </option>
          </select>
          <small class="form-text text-muted">
            Tipo de visualización del listado de opciones para su configuración
          </small>
        </div>
        <div
            class="col-md-6 mt-3"
            v-if="optionConfigure.extra.type === 'tree'"
        >
          <label>Máximo de nodos</label>
          <input
              class="form-control"
              v-model="optionConfigure.extra.maxTreeNodes"
              max="10"
              type="number"
          >
          <small class="form-text text-muted">
            Hasta cuantos nodos puede tener un arbol
          </small>
        </div>
        <div class="col-12" v-if="checkIfIsSuperAdmin">
          <vue-json-editor
            v-model="optionConfigure.extra"
            mode="code"
            :modes="['code']"
            :show-btns="false"
            :exapndedOnStart="true"
            @json-change="onExtraJsonChange"
            @has-error="onExtraJsonError"
          />
          <div v-if="!jsonExtraValid" class="text-danger mt-1">
            El JSON del campo extra no es válido. Corrija la sintaxis para poder guardar.
          </div>
        </div>
        <div class="col-12" v-if="checkIfIsSuperAdmin">
          <h3>Template base para extras de una nueva opción</h3>
          <vue-json-editor
            v-model="optionConfigure.extra.extras"
            mode="code"
            :modes="['code']"
            :show-btns="false"
            :exapndedOnStart="true"
            @json-change="onExtrasJsonChange"
            @has-error="onExtrasJsonError"
          />
          <div v-if="!jsonExtrasValid" class="text-danger mt-1">
            El JSON del campo extras no es válido. Corrija la sintaxis para poder guardar.
          </div>
        </div>
        <div class="col-md-12 mt-3">
          <div style="float: right">
            <vs-button
                class="action"
                color="primary"
                type="border"
                icon="save"
                @click="saveOption()"
                :disabled="!isJsonValid"
                v-if="!isSavingOption"
            >
              Guardar
            </vs-button>
            <b-spinner
                v-else
                key="primary"
                class="mr-1"
                variant="primary"
            />
          </div>
        </div>
      </div>
    </b-modal>
    <option-migration-modal ref="option-migration-modal"/>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue';
import vueJsonEditor from 'vue-json-editor';
import { mapGetters } from 'vuex';
import { uuid } from 'vue-uuid';

import themeConfig from '@/../themeConfig';
import { ioListOptions, ioSaveOption } from '@/febos/servicios/api/herramientas.api';
import OptionsConfigurationsTree from '@/febos/global/empresas/componentes/options/OptionsConfigurationsTree';
import OptionsConfigurationsList from '@/febos/global/empresas/componentes/options/OptionsConfigurationsList';
import { OPTION_LEVELS } from '@/febos/global/empresas/componentes/options/OptionConfigurationsMixin';
import OptionMigrationModal from '@/febos/global/empresas/componentes/options/OptionMigrationModal';

const GROUP_ID = 'opciones_grupos';
const DEFAULT_EXTRA = {
  valueTypes: 'text',
  type: 'list',
  maxTreeNodes: 3,
  nivel: 10
};
export default {
  name: 'Configuraciones',
  components: {
    BSpinner,
    OptionsConfigurationsTree,
    OptionsConfigurationsList,
    OptionMigrationModal,
    vueJsonEditor
  },
  data() {
    return {
      environmentsToMigrate: [],
      isEditingOption: false,
      isLoadOptions: true,
      isSavingOption: false,
      themeConfig,
      search: '',
      options: [],
      optionSelected: null,
      optionConfigure: null,
      jsonExtraValid: true,
      jsonExtrasValid: true
    };
  },
  mounted() {
    this.loadOptions();
  },
  watch: {
    selectedUserId() {
      this.loadOptions();
    }
  },
  computed: {
    ...mapGetters('Usuario', ['hasPermission']),
    filteredOptions() {
      if (!this.search) {
        return this.options;
      }
      const word = this.search.toLowerCase();
      return this.options.filter(
        (option) =>
          option.descripcion.toLowerCase().includes(word) ||
          (option.valor && option.valor.toLowerCase().includes(word))
      );
    },
    checkIfIsSuperAdmin() {
      return this.hasPermission('FEB99');
    },
    isJsonValid() {
      return this.jsonExtraValid && this.jsonExtrasValid;
    }
  },
  methods: {
    selectOptionPatent(option) {
      this.optionSelected = {
        ...option,
        extra: { ...DEFAULT_EXTRA, ...JSON.parse(option.extra || '{}') }
      };
    },
    async loadOptions() {
      try {
        this.isLoadOptions = true;
        const response = await ioListOptions({
          grupoOpcion: GROUP_ID,
          filtros: 'deshabilitado:0'
        });
        const { opciones } = response.data;
        this.options = opciones;
      } finally {
        this.isLoadOptions = false;
      }
    },
    addOptionGroup() {
      this.isEditingOption = false;
      const optionId = uuid.v4();
      this.optionConfigure = {
        descripcion: '',
        deshabilitado: 0,
        grupoId: GROUP_ID,
        orden: this.options.length,
        nivel: 0,
        opcionId: optionId,
        parametroId: optionId,
        valor: '',
        extra: DEFAULT_EXTRA
      };
      this.jsonExtraValid = true;
      this.jsonExtrasValid = true;
      this.$refs['option-config'].show();
    },
    migrateOptionGroup(option) {
      this.$refs['option-migration-modal'].setOption(option);
      this.$refs['option-migration-modal'].show();
    },
    editOptionGroup(option) {
      this.isEditingOption = true;
      this.optionConfigure = {
        ...option,
        extra: { ...DEFAULT_EXTRA, ...JSON.parse(option.extra || '{}') }
      };
      this.jsonExtraValid = true;
      this.jsonExtrasValid = true;
      this.$refs['option-config'].show();
    },
    async deleteOptionGroup(option) {
      this.isLoadOptions = true;
      try {
        const optionDelete = {
          ...option,
          deshabilitado: 1
        };
        const param = {
          global: option.nivel === OPTION_LEVELS.GLOBAL ? 'si' : 'no',
          id: optionDelete.opcionId
        };
        const response = await ioSaveOption(param, optionDelete);
        const { opcion: savedOption } = response.data;
        const filteredOptions = this.options.filter(
          (optionItem) => optionItem.opcionId !== savedOption.opcionId
        );
        this.options = filteredOptions;
      } finally {
        this.isLoadOptions = false;
      }
    },
    onExtraJsonChange(value) {
      this.optionConfigure.extra = value;
      this.jsonExtraValid = true;
    },
    onExtraJsonError() {
      this.jsonExtraValid = false;
    },
    onExtrasJsonChange(value) {
      this.optionConfigure.extra.extras = value;
      this.jsonExtrasValid = true;
    },
    onExtrasJsonError() {
      this.jsonExtrasValid = false;
    },
    async saveOption() {
      if (!this.isJsonValid) return;
      const optionToSave = {
        ...this.optionConfigure,
        extra: JSON.stringify(this.optionConfigure.extra)
      };
      const param = {
        global: +optionToSave.nivel === OPTION_LEVELS.GLOBAL ? 'si' : 'no',
        id: optionToSave.opcionId
      };
      this.isSavingOption = true;
      try {
        const response = await ioSaveOption(param, optionToSave);
        const { opcion: savedOption } = response.data;
        const optionIndex = this.options.findIndex(
          (optionItem) => optionItem.opcionId === savedOption.opcionId
        );
        if (optionIndex > -1) {
          this.options = [
            ...this.options.slice(0, optionIndex),
            ...[savedOption],
            ...this.options.slice(optionIndex + 1)
          ];
        } else {
          this.options.push(savedOption);
        }
        this.$refs['option-config'].hide();
      } finally {
        this.isSavingOption = false;
      }
    }
  }
};
</script>
